import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { assignReviewer, bulkSignoff, getQueueSummary } from '../api/queue';
import type { QueueCounters, QueueRow, QueueSummary } from '../api/queue';

export type { QueueCounters, QueueRow, QueueSummary };

export function useAdminQueue(mine = false) {
  return useQuery({
    queryKey: ['admin-queue-summary', mine],
    queryFn: () => getQueueSummary(mine),
    refetchInterval: 15000,
    refetchIntervalInBackground: false,
  });
}

/** B1 — assign/claim a client's current close to a reviewer. */
export function useAssignReviewer() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: assignReviewer,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin-queue-summary'] }),
  });
}

/** B5 — cross-client bulk sign-off. */
export function useBulkSignoff() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: bulkSignoff,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin-queue-summary'] }),
  });
}
